import { useLocalStorage } from 'usehooks-ts';
import { Locale } from 'locale-enum';

export interface AppDefaults {
  culture?: Locale | string;
  tenantId?: string;
  userId?: string;
  username?: string;
}

export const useAppDefaults = (): ReturnType<typeof useLocalStorage<AppDefaults | undefined>> => {
  return useLocalStorage<AppDefaults | undefined>('app', undefined);
};
